/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_PathInputs */



/**
* | output |
* | --- |
* | "Media Path" |
*
* @param {Media_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_path = /** @type {((inputs?: Media_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chemin du média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienpfad")
	if (locale === "it") return /** @type {LocalizedString} */ ("Percorso multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Путь к медиафайлу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ruta de los medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体路径")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアパス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया पथ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caminho da mídia")
	return /** @type {LocalizedString} */ ("Media Path")
});